import type {DesignerActionFromCreator} from '@packages/systems/designer/flux';
import {createAction} from '@packages/utilities/create-action';

export const COLLECTIONS_UPGRADE_ATTEMPTED = 'COLLECTIONS_UPGRADE_ATTEMPTED';

export const collectionsUpgradeAttempted = createAction<
  typeof COLLECTIONS_UPGRADE_ATTEMPTED,
  {databaseId?: string}
>(COLLECTIONS_UPGRADE_ATTEMPTED);

export type CollectionsUpgradeAttemptedAction = DesignerActionFromCreator<
  typeof collectionsUpgradeAttempted
>;

export const COLLECTIONS_UPGRADED = 'COLLECTIONS_UPGRADED';
